/* This component is a fork from the owner picker backstage component
  Modified to be able to pick multiple type. Github link to owner picker: 
  https://github.com/backstage/backstage/blob/master/plugins/catalog-react/src/components/EntityOwnerPicker/EntityOwnerPicker.tsx
*/
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import React, { useEffect, useMemo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  useEntityList,
  useEntityTypeFilter,
} from '@backstage/plugin-catalog-react';
import { CatalogAutocomplete } from './CatalogAutocomplete';

/** @public */
export type CatalogReactEntityOwnerPickerClassKey = 'input';

const useStyles = makeStyles(
  {
    root: {},
    label: {},
    input: {},
    fullWidth: { width: '100%' },
    boxLabel: {
      width: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  },
  { name: 'CatalogReactEntityOwnerPicker' },
);

/** @public */
export type FixedWidthFormControlLabelClassKey = 'label' | 'root';

const FixedWidthFormControlLabel = withStyles(
  _theme => ({
    label: {
      width: '100%',
    },
    root: {
      width: '90%',
    },
  }),
  { name: 'FixedWidthFormControlLabel' },
)(FormControlLabel);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// /**
//  * @public
//  */
// export type EntityOwnerPickerProps = {
//   mode?: 'owners-only' | 'all';
// };

function RenderOptionLabel(props: { title: string; isSelected: boolean }) {
  const classes = useStyles();
  // const isGroup = props.entity.kind.toLocaleLowerCase('en-US') === 'group';
  // const { primaryTitle: title } = useEntityPresentation(props.entity);
  return (
    <Box className={classes.fullWidth}>
      <FixedWidthFormControlLabel
        className={classes.fullWidth}
        control={
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            checked={props.isSelected}
          />
        }
        onClick={event => event.preventDefault()}
        label={
          <Tooltip title={props.title}>
            <Box display="flex" alignItems="center">
              &nbsp;
              <Box className={classes.boxLabel}>
                <Typography noWrap>{props.title}</Typography>
              </Box>
            </Box>
          </Tooltip>
        }
      />
    </Box>
  );
}

/** @public */
export const TypePicker = () => {
  const classes = useStyles();
  const {
    filters,
    queryParameters: { type: typeParameter },
  } = useEntityList();

  const queryParamTypes = useMemo(
    () => [typeParameter].flat().filter(Boolean) as string[],
    [typeParameter],
  );

  const { availableTypes, selectedTypes, setSelectedTypes, loading } =
    useEntityTypeFilter();

  // Set selected owners on query parameter updates; this happens at initial page load and from
  // external updates to the page location.
  useEffect(() => {
    if (queryParamTypes.length) {
      setSelectedTypes(queryParamTypes);
    }
  }, [queryParamTypes, setSelectedTypes]);

  useEffect(() => {
    setSelectedTypes(selectedTypes);
  }, [selectedTypes, setSelectedTypes]);

  if (
    ['user', 'group'].includes(
      filters.kind?.value.toLocaleLowerCase('en-US') || '',
    )
  ) {
    return null;
  }

  return (
    <Box className={classes.root} pb={1} pt={1}>
      <CatalogAutocomplete<string, true>
        label="Type"
        multiple
        disableCloseOnSelect
        loading={loading}
        options={availableTypes.sort((a, b) => a.localeCompare(b))} // Sort types alphabetically
        value={selectedTypes}
        getOptionSelected={(o, v) => {
          return o === v;
        }}
        getOptionLabel={o => {
          return o;
        }}
        onChange={(_: object, types) => {
          setSelectedTypes(
            types.map(e => {
              return e;
            }),
          );
        }}
        filterOptions={x => x}
        renderOption={(entity, { selected }) => {
          return <RenderOptionLabel title={entity} isSelected={selected} />;
        }}
        name="type-picker"
        ListboxProps={{
          'data-testid': 'type-picker-listbox',
        }}
        LabelProps={{ className: classes.label }}
        TextFieldProps={{ className: classes.input }}
      />
    </Box>
  );
};
